import { useMemo } from 'react';
import { useAppSelector } from './useAppRedux';
import { getLocale, localizeDigits, translate } from '../i18n';

export const useI18n = () => {
  const language = useAppSelector((state) => state.app.language);

  return useMemo(() => ({
    language,
    locale: getLocale(language),
    localizeDigits: (value) => localizeDigits(value, language),
    formatDate: (value, options) => new Intl.DateTimeFormat(getLocale(language), options).format(new Date(value)),
    formatNumber: (value) => localizeDigits(value, language),
    t: (key, params) => translate(language, key, params)
  }), [language]);
};
